export const PHONES = [
  '0 800 807-888',
  '(073) 466-28-88'
];
